// extracted by mini-css-extract-plugin
export default {"center":"App_center__r0WPV","logo":"App_logo__Pn096"};